import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Tweet } from '@blocks/kit';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "terminal"
    }}>{`Terminal`}</h1>
    <p>{`With MDX you can render to the command line using `}<a parentName="p" {...{
        "href": "https://github.com/vadimdemedes/ink"
      }}>{`Ink`}</a>{`.
This is a great way to log structured text for welcome screens,
options, or even error messages.`}</p>
    <h2 {...{
      "id": "how-it-works"
    }}>{`How it works`}</h2>
    <p>{`Ink is a toolkit that lets you render React to the terminal, so
with very little work you can also render MDX using the
`}<a parentName="p" {...{
        "href": "https://mdxjs.com/advanced/runtime"
      }}>{`runtime library`}</a>{`.
This library handles MDX transpilation and evaluating the output
React code.
Ink then handles the resulting DOM structure and outputs a CLI
string.`}</p>
    <h2 {...{
      "id": "install-mdx-runtime"
    }}>{`Install MDX runtime`}</h2>
    <p>{`In order to use MDX you’ll have to use `}<a parentName="p" {...{
        "href": "https://mdxjs.com/advanced/runtime"
      }}>{`the MDX runtime`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`yarn add @mdx-js/runtime
`}</code></pre>
    <h2 {...{
      "id": "using-components"
    }}>{`Using components`}</h2>
    <p>{`Ink provides built in components for layout and color which you can
use with the MDXProvider to customize the functionality and appearance
of components.`}</p>
    <p>{`Create a `}<inlineCode parentName="p">{`components`}</inlineCode>{` object and pass it to the MDXProvider.
It’s important to ensure that the MDXProvider wraps the MDX runtime
component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const React = require('react')
const {Text, render} = require('ink')
const {MDXProvider} = require('@mdx-js/react')
const MDX = require('@mdx-js/runtime')

const components = {
  h1: ({ children }) => <Text bold>{children}</Text>,
  p: ({ children }) => <Text>{children}</Text>
}

render(
  <MDXProvider components={components}>
    <MDX>{MDXContent}</MDX>
  </MDXProvider>
);
`}</code></pre>
    <p>{`You can also provide other components to the runtime scope for additional
functionality.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const components = {
  Box,
  Color,
  Text,
  h1: ({ children }) => <Text bold>{children}</Text>,
  p: ({ children }) => <Text>{children}</Text>
}
`}</code></pre>
    <p>{`This will allow you to write content like the following
(and render it to the terminal!):`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-mdx"
      }}>{`# Hello, world!

From <Color bgBlack white bold>    MDX!    </Color>

<Box marginTop={1}>
  <Color bgCyan white bold>
    I'm a cyan box!
  </Color>
</Box>
`}</code></pre>
    <h2 {...{
      "id": "all-together"
    }}>{`All together`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const React = require('react');
const {render, Color, Box, Text} = require('ink');
const MDX = require('@mdx-js/runtime')
const { MDXProvider } = require('@mdx-js/react')

const MDXContent = \`
# Hello, world!

From <Color bgBlack white bold>    MDX!    </Color>

<Box marginTop={1}>
  <Color bgCyan white bold>
    I'm a cyan box!
  </Color>
</Box>
\`

const components = {
  Box,
  Color,
  h1: ({ children }) => <Text bold>{children}</Text>,
  p: ({ children }) => <Text>{children}</Text>
}

render(
  <MDXProvider components={components}>
    <MDX>{MDXContent}</MDX>
  </MDXProvider>
);
`}</code></pre>
    <Tweet tweetId="1141781114786160641" mdxType="Tweet" />
    <p><a parentName="p" {...{
        "href": "https://github.com/mdx-js/mdx/tree/master/examples/cli"
      }}>{`See the full example`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      